import { CertificateRegistryApiTypes } from "@rshbintech.dboul/http";
import { CUSTOM_ERROR_KEYS } from "../constants";

export const chooseValidCertificate = (
  certificates: CertificateRegistryApiTypes.ShortCertInfo[]
): never | CertificateRegistryApiTypes.ShortCertInfo => {
  if (certificates.length < 1) {
    throw new Error(CUSTOM_ERROR_KEYS.ACTIVE_CERTIFICATE_NOT_FOUND);
  }

  if (certificates.length < 2) {
    return certificates[0];
  }

  let activeCertificateTimeStamp;
  let certificateNumber;
  const now = new Date().getTime();

  for (let i = 0; i < certificates.length; i++) {
    const validDate = certificates[i].notBefore.slice(0, -1);
    const dateInMs = new Date(validDate).getTime();

    if (dateInMs > Number(activeCertificateTimeStamp) && dateInMs > now) {
      activeCertificateTimeStamp = dateInMs;
      certificateNumber = i;
    }
  }

  if (certificateNumber) {
    return certificates[certificateNumber];
  }

  throw new Error(CUSTOM_ERROR_KEYS.ACTIVE_CERTIFICATE_NOT_FOUND);
};
